"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var add_filters_button_html_1 = __importDefault(require("./add-filters-button.html"));
require("../filters.less");
var filter_utils_1 = require("@shared/utils/filter-utils");
(function (module) {
    'use strict';
    var AddFiltersButtonController = function ($scope, Filters, prFilterUtils, setPRFilters) {
        var self = this;
        self.$onInit = function () {
            _.merge(self, _.pick($scope, ['setFilters', 'sourceIds', 'breakoutFilters']));
            self.$scope = $scope;
            self.init(true);
        };
        self.$onChanges = function (changes) {
            // monitor changes, if sourceIds is changed, init component
            var currentSourceIds = changes.sourceIds;
            if (currentSourceIds && !currentSourceIds.isFirstChange()
                && !_.isEqual(currentSourceIds.currentValue, currentSourceIds.previousValue)) {
                return self.init(true);
            }
        };
        /**
         * Initializes the singleton Filter when selected
         *
         * @param {bool} shouldReInit - used by add-filters-button to reinit Filter with empty args
         * 								to clear so that it's not bound to any existing filters
        **/
        self.init = function (shouldReInit) {
            self.waitForInit = true;
            self.hasSavedFilters = false;
            self.sourceDefs = {};
            self.sourceFilter = _.cloneDeep((self.filters || {})[self.sourceIds[0]] || {});
            self.filterService = new Filters(self.sourceIds[0], self.sourceFilter, setPRFilters.setPRFilters(self, true));
            if (!_.isEmpty(self.sourceFilter)) {
                // Fix old PR date filters
                prFilterUtils.fixDateFilters(self.sourceFilter);
                filter_utils_1.fixOldPRFilters(self.sourceFilter);
            }
            self.canFilter = function () {
                return self.filterService.canFilter();
            };
            return self.filterService.init()
                .then(function () {
                return self.filterService.hasSavedFilters();
            })
                .then(function (hasSavedFilters) {
                self.hasSavedFilters = hasSavedFilters;
                self.hasFilterApplied = (self.filterService.hasValidFilterApplied() || self.filterService.isValidFilter(self.sourceFilter));
                self.waitForInit = false;
                if (shouldReInit) {
                    self.init();
                }
            });
        };
    };
    AddFiltersButtonController.prototype.getFiltersMenu = function () {
        var self = this;
        return this.filterService.getFiltersMenu().then(function (menu) {
            menu = self.generateDynamicMenu(menu);
            self.showMenu = !!(menu.length);
            return menu;
        });
    };
    AddFiltersButtonController.prototype.generateDynamicMenu = function (menu) {
        menu = _.cloneDeep(menu);
        menu = this.removeUsedFilters(this.breakoutFilters, menu, this.sourceIds[0]);
        if (menu.length === 2) {
            _.remove(menu, { divider: true });
        }
        return menu;
    };
    AddFiltersButtonController.prototype.removeUsedFilters = function (breakoutFilters, menu, sourceId) {
        _.forEach(breakoutFilters, function (breakoutFilter) {
            _.remove(menu, function (item) {
                if (item && item.value && item.value.id) {
                    return item.value.id === breakoutFilter[sourceId].filterId;
                }
                return false;
            });
        });
        return menu;
    };
    AddFiltersButtonController.prototype.openManageFiltersModal = function () {
        return this.filterService.openManageFiltersModal();
    };
    AddFiltersButtonController.prototype.selectFilterMenuItem = function (selectedMenuItem) {
        var self = this;
        this.init().then(function () {
            return self.filterService.selectFilterMenuItem(selectedMenuItem);
        });
    };
    AddFiltersButtonController.$inject = ['$scope', 'prFilterService', 'prFilterUtils', 'prSetPRFiltersFactory'];
    module.controller('addFiltersButtonController', AddFiltersButtonController);
    module.component('prAddFiltersButton', {
        templateUrl: add_filters_button_html_1.default,
        controller: 'addFiltersButtonController as $ctrl',
        bindings: {
            setFilters: '&',
            sourceIds: '<',
            breakoutFilters: '<'
        }
    });
})(angular.module('qualtrics.pr'));
